import { useAuth } from "@clerk/clerk-expo";

import { useAuthStore } from "@/store";

export const useAuthState = () => {
  const { isAuthInitialized, anonymousUserId } = useAuthStore();
  const { isLoaded, isSignedIn, userId } = useAuth();

  return {
    isSignedIn,
    isLoading: !isLoaded,
    isInitializing: !isAuthInitialized,
    userId: userId,
    anonymousUserId,
  };
};
